'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _abp = require('abp');

var _abp2 = _interopRequireDefault(_abp);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

var _reactGoogleRecaptcha = require('react-google-recaptcha');

var _reactGoogleRecaptcha2 = _interopRequireDefault(_reactGoogleRecaptcha);

var _reactStarRatingComponent = require('react-star-rating-component');

var _reactStarRatingComponent2 = _interopRequireDefault(_reactStarRatingComponent);

var _cookie = require('linksoft/utils/cookie');

var _cookie2 = _interopRequireDefault(_cookie);

var _message = require('linksoft/message');

var _message2 = _interopRequireDefault(_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var productRatingService = _abp2.default.services.api.productRating;

var CaptchaRating = (_temp = _class = function (_React$Component) {
    (0, _inherits3.default)(CaptchaRating, _React$Component);

    function CaptchaRating(props) {
        (0, _classCallCheck3.default)(this, CaptchaRating);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CaptchaRating.__proto__ || (0, _getPrototypeOf2.default)(CaptchaRating)).call(this, props));

        _this.siteKey = props.siteKey;
        _this.productId = props.productId;
        _this.onCaptchaChange = _this.onCaptchaChange.bind(_this);
        _this.cookieName = 'ratingCookie';
        _this.newValue = 0;

        _this.state = {
            rating: 0,
            clicked: false,
            identifier: Math.round(Math.random() * 1000)
        };

        _this.ratingCookie = _cookie2.default.getCookie(_this.cookieName) || '';
        return _this;
    }

    (0, _createClass3.default)(CaptchaRating, [{
        key: 'onCaptchaChange',
        value: function onCaptchaChange(token) {
            var _this2 = this;

            var rating = this.state.rating;

            var clickedStateHandler = function clickedStateHandler() {
                return _this2.setState({ clicked: false });
            };
            productRatingService.addRating(this.productId, rating, token).done(function (xhr) {

                if (xhr.issucess) {
                    _notify2.default.success(xhr.statusmessage);
                    clickedStateHandler();
                    grecaptcha.reset();
                } else {
                    _notify2.default.error(xhr.statusmessage);
                }
            }).fail(function (result) {
                _notify2.default.error(Resx.Validation.UnauthorizedDataOperation);
            });
        }
    }, {
        key: 'onCaptchaExpired',
        value: function onCaptchaExpired() {}
    }, {
        key: 'getProductRatingFromCookie',
        value: function getProductRatingFromCookie() {
            var productsFromCookie = this.ratingCookie.match(/[0-9:]+/g) || [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(productsFromCookie), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var productRatingValue = _step.value;

                    var valueArray = productRatingValue.split(':');

                    if (parseInt(valueArray[0]) === this.productId) {
                        return { productId: valueArray[0], rating: valueArray.length === 2 ? valueArray[1] : 0 };
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return null;
        }
    }, {
        key: 'onStarClick',
        value: function onStarClick(nextValue, prevValue, name) {
            var _this3 = this;

            this.newValue = nextValue;
            var productRated = this.getProductRatingFromCookie();

            // if product exists in cookie, then it means, this user already posted rating
            if (productRated) {
                _message2.default.confirm(Resx.Messages.ConfirmRatingMessage, Resx.Messages.ConfirmRatingTitle, function (isConfirmed) {
                    if (isConfirmed) {
                        _this3.updateRating();
                    }
                }).catch(function () {});
            } else {
                this.updateRating();
            }
        }
    }, {
        key: 'updateRating',
        value: function updateRating() {
            this.setState({ rating: this.newValue });
            this.setState({ clicked: true });
            _notify2.default.info(Resx.Messages.CaptchaNotice);

            // finally set cookie value after original cookie value without all existing ratings of current product
            var regex = new RegExp('[|]?' + this.productId + '(:[0-5])?', 'g');
            this.ratingCookie = (this.ratingCookie || '').replaceAll(regex, '') + '|' + this.productId + ':' + (this.newValue || 0);
            _cookie2.default.setCookie(this.cookieName, this.ratingCookie, 365 * 5);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var _state = this.state,
                rating = _state.rating,
                clicked = _state.clicked;

            // for first load - take value from cookie

            if (!rating) {
                var existingRating = this.getProductRatingFromCookie();
                if (existingRating && existingRating.rating > 0) {
                    rating = parseInt(existingRating.rating);
                }
            }

            return _react2.default.createElement(
                'div',
                { className: 'br-widget' },
                _react2.default.createElement(_reactStarRatingComponent2.default, {
                    id: 'ratingElement',
                    name: 'rate_' + this.state.identifier,
                    starCount: 5,
                    value: rating,
                    renderStarIcon: function renderStarIcon(index, value) {
                        return _react2.default.createElement('a', { className: index === value ? 'br-current' : '' });
                    },
                    onStarClick: this.onStarClick.bind(this)
                }),
                _react2.default.createElement(
                    'div',
                    { className: clicked ? "captcha-stars active" : "captcha-stars" },
                    _react2.default.createElement(_reactGoogleRecaptcha2.default, {
                        sitekey: this.siteKey,
                        type: 'image',
                        theme: 'light',
                        onChange: function onChange(token) {
                            return _this4.onCaptchaChange(token);
                        },
                        onExpired: function onExpired(value) {
                            return _this4.onCaptchaExpired();
                        } }),
                    _react2.default.createElement('div', { className: 'clear' })
                )
            );
        }
    }]);
    return CaptchaRating;
}(_react2.default.Component), _class.propTypes = {
    siteKey: _propTypes2.default.string.isRequired,
    productId: _propTypes2.default.number.isRequired
}, _temp);
exports.default = CaptchaRating;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/recaptcha/captchaRating.js
// module id = 1090
// module chunks = 0